module.exports = __webpack_public_path__ + "static/media/batch-icon.50623785.svg";